module.exports = __webpack_public_path__ + "static/media/erin_kwon.6f428c9e.png";